import { PRODUCT_CODE_QUERY_KEY, REDIRECT_URL_QUERY_KEY } from "@/features/auth/constant/login";
import { usePostLoginRedirect } from "@/features/auth/hooks/usePostLoginRedirect";
import { hasPasskeyOnDevice, isPasskeyCancellation, isPasskeySupported, loginWithPasskey } from "@/features/auth/utils/passkey";
import { showError } from "@/utils/error";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

type TUsePasskeyLoginOptions = {
  autoStart?: boolean;
};

let autoStartedThisLoad = false;

export const usePasskeyLogin = ({ autoStart = false }: TUsePasskeyLoginOptions = {}) => {
  const redirectAfterLogin = usePostLoginRedirect();
  const [isPasskeyLoading, setIsPasskeyLoading] = useState(false);
  const handlePasskeyLoginRef = useRef<() => void>();
  const [searchParams] = useSearchParams();

  const handlePasskeyLogin = async () => {
    setIsPasskeyLoading(true);
    try {
      await loginWithPasskey();

      redirectAfterLogin({
        productCode: searchParams.get(PRODUCT_CODE_QUERY_KEY),
        redirectUrl: searchParams.get(REDIRECT_URL_QUERY_KEY),
      });
    } catch (error) {
      if (!isPasskeyCancellation(error)) showError(error);
    } finally {
      setIsPasskeyLoading(false);
    }
  };
  handlePasskeyLoginRef.current = handlePasskeyLogin;

  useEffect(() => {
    // Only auto-prompt when this device is known to hold a passkey (login page is usernameless).
    if (!autoStart || !isPasskeySupported() || !hasPasskeyOnDevice() || autoStartedThisLoad) return;
    autoStartedThisLoad = true;
    handlePasskeyLoginRef.current?.();
  }, [autoStart]);

  return { isPasskeyLoading, handlePasskeyLogin };
};
